import React from "react";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import Button from "shared/Button";
import { colors } from "styles/colors";
import { addGrocery } from "api/api";
import { TitleIngredients } from "components/RecipeSteps/Preview/styled";
import { setInGrocery } from "../../store/collectionReducer";
import { AddToGroceryWrapper } from "./styled";

const IngredientsTitle = ({
  id,
  type,
  isInGrocery,
  purchased,
  paid,
  isActive,
  isPrivate,
  isLogin,
  showLogin,
  showPayment,
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const isPaidSingle = !purchased && paid && !isPrivate;
  const isPaidInCollection = !purchased && isPrivate;

  const onClick = async () => {
    if (isPaidInCollection) {
      return;
    } else if (!isLogin) {
      showLogin();
    } else if (isPaidSingle) {
      showPayment();
    } else if (isInGrocery) {
      router.push("/grocery-list");
    } else {
      dispatch(setInGrocery());
      await addGrocery({ type, id });
    }
  };

  return (
    <AddToGroceryWrapper isInGrocery={isInGrocery} isInactive={!isLogin || !isActive}>
      <TitleIngredients>Ingredients</TitleIngredients>
      <Button
        color={colors.WHITE}
        textColor={isInGrocery ? colors.GREEN : colors.RED}
        stylType="outline"
        border={colors.WHITE}
        text={isInGrocery ? "In your Grocery List" : "Add to Grocery List"}
        iconRight={isInGrocery ? "check" : "plus"}
        tooltip={isPaidInCollection ? "Please, purchase the collection first" : false}
        onClick={onClick}
      />
    </AddToGroceryWrapper>
  );
};

export default IngredientsTitle;
